module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row lobby-article-search-list"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "articles-body"
  }, [_c('div', {
    staticClass: "text-center mb20"
  }, [_c('span', {
    staticClass: "f20"
  }, [_vm._v("文章搜索: " + _vm._s(_vm.title))])]), _vm._v(" "), _vm._l((_vm.pager.articles), function(article) {
    return _c('div', {
      staticClass: "mb10"
    }, [_c('span', {
      class: 'text-' + article.getTypeMap().style
    }, [_vm._v("\n\t\t\t\t\t[" + _vm._s(article.getTypeMap().name) + "]\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "nb-a",
      on: {
        "click": function($event) {
          _vm.$router.push(article.detailPageUrl())
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(article.title))
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("simpleDate")(article.releaseTime)) + "\n\t\t\t\t")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('NbPager', {
    attrs: {
      "pager": _vm.pager,
      "callback": _vm.refresh
    }
  })], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-547f7e2f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/article/Search.vue
// module id = 983
// module chunks = 1